/* batida-v7-catering-page.js: /pages/catering-dla-firm of the new batida.pl (Aleksandra's prototype, 27.09).
   Everything works without it (the pills jump to the form, the SEO text is open, "Dołącz logo" is an e-mail link).
   - occasion pills: write "Okazja: …" into the form's message and go to the form (-occasions, -form)
   - F23 (29.09): links from elsewhere fill the form: ?okazja=<name> (like a pill), ?temat=<topic> picks it in
     "Co Was interesuje?" (added to the list when the list doesn't have it), ?pakiet=<name> adds "<topic> - pakiet <name>"
     to the message (home "Zapytaj o stację", sections/batida-v7-station.liquid)
   - F26 (29.09): "Dołącz logo" uploads the file to Cloudinary (the cake creator's cloud + unsigned preset, section
     settings) and puts its link into the hidden field contact[Logo], so it arrives in the same e-mail as the enquiry.
     While the file uploads the send button waits; if the upload fails, the e-mail link is shown instead.
   - 06.10 (quote form UX): "Data eventu" is a real <input type="date"> (min = today in the visitor's time zone; a past date
     is refused with an inline message and blocks the submit). The submitted value stays dd.mm.rrrr: the field name moves
     to a hidden twin that JS keeps in step, so Shopify's e-mail / Batida Connect receive what the old text field gave.
     "Dołącz logo" also takes drag & drop, and shows a thumbnail (file icon + name for PDF etc.) with "Zmień" / "Usuń".
   - "Czytaj dalej" under a long SEO text (-seo)
   It never touches the form's submit (Shopify's own contact form + spam check post it normally). */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formParts() {
    var form = document.getElementById('v7f-form');
    return { form: form, msg: form && form.querySelector('textarea[name="contact[body]"]'), what: form && form.querySelector('select[name="contact[Co Was interesuje]"]') };
  }
  // one prefixed line at the top of the message (a second click replaces it instead of adding another)
  function setLine(msg, prefix, line) {
    var lines = msg.value ? msg.value.split('\n') : [];
    var at = -1;
    for (var i = 0; i < lines.length; i++) if (prefix && lines[i].indexOf(prefix) === 0) { at = i; break; }
    if (at >= 0) lines[at] = line; else lines.unshift(line);
    msg.value = lines.join('\n').replace(/\n+$/, '') + '\n';
  }
  function occPrefix(pill) {
    var list = pill ? pill.closest('[data-v7f-prefix]') : document.querySelector('[data-v7f-prefix]');
    return (list && list.getAttribute('data-v7f-prefix')) || 'Okazja:';
  }
  function markPill(name) {
    var n = String(name || '').trim().toLowerCase(), hit = null;
    document.querySelectorAll('[data-v7f-occ]').forEach(function (p) {
      var on = !!n && p.getAttribute('data-v7f-occ').trim().toLowerCase() === n;
      p.classList.toggle('is-on', on); if (on) hit = p;
    });
    return hit;
  }

  // occasion pills -> message field
  document.querySelectorAll('[data-v7f-occ]').forEach(function (pill) {
    pill.addEventListener('click', function (e) {
      var f = formParts(), form = f.form, msg = f.msg;
      if (!msg) return;
      e.preventDefault();
      var prefix = occPrefix(pill);
      setLine(msg, prefix, prefix + ' ' + pill.getAttribute('data-v7f-occ'));
      markPill(pill.getAttribute('data-v7f-occ'));
      form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      setTimeout(function () {
        try { msg.focus({ preventScroll: true }); msg.setSelectionRange(msg.value.length, msg.value.length); } catch (err) {}
      }, reduce ? 0 : 500);
    });
  });

  // F23: ?temat= / ?pakiet= / ?okazja= from links elsewhere on the site
  (function prefill() {
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return; }
    var temat = (q.get('temat') || '').trim().slice(0, 80), pakiet = (q.get('pakiet') || '').trim().slice(0, 60), okazja = (q.get('okazja') || '').trim().slice(0, 80);
    if (!temat && !okazja) return;
    var f = formParts();
    if (!f.form || !f.msg) return;
    if (temat && f.what) {
      var t = temat.toLowerCase(), opt = null;
      Array.prototype.forEach.call(f.what.options, function (o) { if (!opt && o.value.trim().toLowerCase() === t) opt = o; });
      if (!opt) Array.prototype.forEach.call(f.what.options, function (o) { if (!opt && o.value.trim().toLowerCase().indexOf(t) === 0) opt = o; });
      if (!opt) { opt = document.createElement('option'); opt.value = temat; opt.textContent = temat; f.what.insertBefore(opt, f.what.options[0] || null); }
      f.what.value = opt.value;
    }
    var pk = ' - ' + (window.batidaT ? window.batidaT('v7.package', 'pakiet') : 'pakiet');
    if (temat && pakiet) setLine(f.msg, temat + pk, temat + pk + ' ' + pakiet);
    else if (temat && !f.what) setLine(f.msg, temat, temat);
    if (okazja) { var pill = markPill(okazja), prefix = occPrefix(pill); setLine(f.msg, prefix, prefix + ' ' + (pill ? pill.getAttribute('data-v7f-occ') : okazja)); }
  })();

  // 06.10: "Data eventu" -> date picker; still sends dd.mm.rrrr (as the old text field did)
  (function dateField() {
    var el = document.querySelector('[data-v7f-date]');
    if (!el || el.type !== 'date') return;                                       // a browser without a date picker keeps a plain text field
    var form = el.closest('form'), err = document.querySelector('[data-v7f-date-err]');
    var name = el.getAttribute('name'), twin = null;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function todayIso() { var d = new Date(); return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }   // the visitor's local day
    function show(text) {
      if (err) { err.hidden = !text; err.textContent = text || ''; }
      if (text) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
    }
    function sync() {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(el.value);
      if (twin) twin.value = m ? m[3] + '.' + m[2] + '.' + m[1] : '';
    }
    function check() {
      el.min = todayIso();
      var past = !!el.value && el.value < el.min;
      el.setCustomValidity(past ? (el.getAttribute('data-t-past') || ' ') : '');
      return !past;
    }
    el.min = todayIso();
    if (name && form) {                                                            // the name moves to a hidden twin right after the picker (same field order)
      twin = document.createElement('input'); twin.type = 'hidden'; twin.name = name;
      el.removeAttribute('name'); el.parentNode.insertBefore(twin, el.nextSibling);
    }
    function onChange() { show(check() ? '' : el.getAttribute('data-t-past')); sync(); }
    el.addEventListener('input', onChange);
    el.addEventListener('change', onChange);
    el.addEventListener('invalid', function () { if (!check()) show(el.getAttribute('data-t-past')); });
    if (form) {
      // before batida-v7-forms.js (document, capture): a past date never leaves the page, even where native validation is skipped
      window.addEventListener('submit', function (e) {
        if (e.target !== form) return;
        sync();
        if (!check()) { e.preventDefault(); e.stopImmediatePropagation(); show(el.getAttribute('data-t-past')); try { el.focus(); } catch (x) {} }
      }, true);
      form.addEventListener('reset', function () { setTimeout(function () { show(''); sync(); }, 0); });
    }
    sync();
  })();

  // F26: "Dołącz logo" -> Cloudinary -> contact[Logo]  (06.10: + drag & drop, thumbnail, "Zmień" / "Usuń"; the upload itself is unchanged)
  document.querySelectorAll('[data-v7f-logo]').forEach(function (box) {
    var file = box.querySelector('[data-v7f-logo-file]'), url = box.querySelector('[data-v7f-logo-url]');
    var btn = box.querySelector('[data-v7f-logo-btn]'), mail = box.querySelector('[data-v7f-logo-mail]'), msg = box.querySelector('[data-v7f-logo-msg]');
    var cloud = box.getAttribute('data-cloud'), preset = box.getAttribute('data-preset');
    if (!file || !url || !btn || !cloud || !preset) return;                       // keeps the e-mail link
    var form = box.closest('form'), send = form && form.querySelector('[type="submit"]');
    var label = btn.querySelector('[data-v7f-logo-label]'), label0 = label ? label.textContent : '';
    var drop = box.querySelector('[data-v7f-logo-drop]'), prev = box.querySelector('[data-v7f-logo-prev]');
    var thumb = box.querySelector('[data-v7f-logo-thumb]'), nameEl = box.querySelector('[data-v7f-logo-name]');
    var bChange = box.querySelector('[data-v7f-logo-change]'), bRemove = box.querySelector('[data-v7f-logo-remove]');
    var T = { busy: box.getAttribute('data-t-busy'), done: box.getAttribute('data-t-done'), err: box.getAttribute('data-t-err'), type: box.getAttribute('data-t-type'), wait: box.getAttribute('data-t-wait'), mail: box.getAttribute('data-t-mail'),
      drop: box.getAttribute('data-t-drop'), dropOn: box.getAttribute('data-t-drop-on'), change: box.getAttribute('data-t-change') || 'Zmień', remove: box.getAttribute('data-t-remove') || 'Usuń' };
    var sendText = send ? send.textContent : '';
    var objUrl = '', depth = 0;
    btn.hidden = false; if (mail) mail.hidden = true;
    if (drop && T.drop) { drop.textContent = T.drop; drop.hidden = false; }
    function note(text, bad) { if (!msg) return; msg.hidden = !text; msg.textContent = text || ''; msg.classList.toggle('is-bad', !!bad); }
    function busy(on) {
      box.classList.toggle('is-busy', on);
      if (send) { send.disabled = on; send.textContent = on ? (T.wait || sendText) : sendText; }
      if (bChange) bChange.disabled = on;
      if (bRemove) bRemove.disabled = on;
    }
    function dropText(on) { if (drop && T.drop) drop.textContent = on ? (T.dropOn || T.drop) : T.drop; }
    function clearThumb() {
      if (objUrl) { try { URL.revokeObjectURL(objUrl); } catch (e) {} objUrl = ''; }
      if (thumb) thumb.textContent = '';
    }
    function showPrev(f) {
      if (!prev) return;
      clearThumb();
      if (thumb) {
        if (/\.(png|svg|jpe?g|webp)$/i.test(f.name) && window.URL && URL.createObjectURL) {
          objUrl = URL.createObjectURL(f);
          var img = document.createElement('img'); img.src = objUrl; img.alt = ''; img.width = 48; img.height = 48;
          thumb.appendChild(img); thumb.classList.remove('is-ico');
        } else {
          var ext = (/\.([a-z0-9]+)$/i.exec(f.name) || [0, ''])[1].toUpperCase().slice(0, 4);
          thumb.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/></svg><b></b>';
          thumb.lastChild.textContent = ext; thumb.classList.add('is-ico');
        }
      }
      if (nameEl) nameEl.textContent = f.name;
      if (bChange) { bChange.textContent = T.change; bChange.setAttribute('aria-label', T.change + ': ' + f.name); }
      if (bRemove) { bRemove.textContent = T.remove; bRemove.setAttribute('aria-label', T.remove + ': ' + f.name); }
      prev.hidden = false; btn.hidden = true; file.tabIndex = -1;
    }
    function hidePrev() { if (prev) prev.hidden = true; clearThumb(); btn.hidden = false; file.tabIndex = 0; }
    function reset() { url.value = ''; box.classList.remove('is-done'); hidePrev(); note(''); if (label) label.textContent = label0; }

    function take(f) {
      if (!f || box.classList.contains('is-busy')) return;
      if (!/\.(png|svg|jpe?g|webp|pdf|ai|eps)$/i.test(f.name) || f.size > 10 * 1024 * 1024) { note(T.type, true); return; }
      var hadFocus = box.contains(document.activeElement);
      url.value = ''; box.classList.remove('is-done'); hidePrev();                // a replaced file is gone until the new one is up
      note(''); busy(true);
      if (label) label.textContent = T.busy || label0;
      var fd = new FormData(); fd.append('file', f); fd.append('upload_preset', preset);
      fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloud) + '/auto/upload', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j || !j.secure_url) throw new Error('upload');
          url.value = j.secure_url + ' (' + f.name + ')';
          box.classList.add('is-done');
          if (label) label.textContent = label0;
          note((T.done || '✓ {plik}').replace('{plik}', f.name));
          showPrev(f);
          if (hadFocus && bChange) { try { bChange.focus(); } catch (e) {} }
        })
        .catch(function () {
          url.value = ''; box.classList.remove('is-done'); hidePrev();
          if (label) label.textContent = label0;
          note(T.err, true); if (mail) { if (T.mail) mail.lastChild.textContent = ' ' + T.mail; mail.hidden = false; }
        })
        .then(function () { busy(false); file.value = ''; });
    }

    file.addEventListener('change', function () { var f = file.files && file.files[0]; if (f) take(f); file.value = ''; });
    if (bChange) bChange.addEventListener('click', function () { file.click(); });
    if (bRemove) bRemove.addEventListener('click', function () { reset(); try { file.focus(); } catch (e) {} });

    // drag & drop onto the field (a counter, because dragenter / dragleave also fire for the children)
    function hasFiles(e) { var t = e.dataTransfer && e.dataTransfer.types; return !!t && Array.prototype.indexOf.call(t, 'Files') >= 0; }
    box.addEventListener('dragenter', function (e) { if (!hasFiles(e)) return; e.preventDefault(); depth++; box.classList.add('is-drag'); dropText(true); });
    box.addEventListener('dragover', function (e) { if (!hasFiles(e)) return; e.preventDefault(); if (e.dataTransfer) e.dataTransfer.dropEffect = 'copy'; });
    box.addEventListener('dragleave', function (e) { if (!hasFiles(e)) return; depth = Math.max(0, depth - 1); if (!depth) { box.classList.remove('is-drag'); dropText(false); } });
    box.addEventListener('drop', function (e) {
      if (!hasFiles(e)) return;
      e.preventDefault(); depth = 0; box.classList.remove('is-drag'); dropText(false);
      take(e.dataTransfer.files && e.dataTransfer.files[0]);
    });
  });

  // "Czytaj dalej"
  document.querySelectorAll('[data-v7f-clamp]').forEach(function (box) {
    var btn = box.parentNode.querySelector('[data-v7f-clamp-btn]');
    if (!btn) return;
    box.classList.add('is-clamp');
    if (box.scrollHeight <= box.clientHeight + 24) { box.classList.remove('is-clamp'); return; }
    var more = btn.textContent, less = btn.getAttribute('data-less') || more;
    btn.hidden = false;
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var x = box.classList.toggle('is-clamp');
      btn.textContent = x ? more : less;
      btn.setAttribute('aria-expanded', x ? 'false' : 'true');
    });
  });
})();
